export const Urls = {
  GetPortEmissionTypesConfig: "MepEmissionTargetConfig/GetPortEmissionTypesConfig",
  GetPortEmissionTypesConfigDetail: "MepEmissionTargetConfig/GetPortEmissionTypesConfigDetail",
  GetPortEmissionTargetInitData: "MepEmissionTargetConfig/GetPortEmissionTargetInitData",
  CreateOrUpdateEmissionTypeConfig: "MepEmissionTargetConfig/CreateOrUpdateEmissionTypeConfig",
  DeleteEmissionTypeConfig: "MepEmissionTargetConfig/DeleteEmissionTypeConfig",
  UpdateLongTermYearConfig: "MepEmissionTargetConfig/UpdateLongTermYearConfig"
}
